export const authMiddleware = store => next => async action => {
    const actionType = action.type.toLowerCase()
    if (actionType.includes('api') && actionType.includes('rejected')) {
        const result = next(action)

        if (result?.payload && result.payload?.status === 401) {
            const token = localStorage.removeItem('user')
        }
    }

    return next(action)
}
